
import { Component, Vue } from "vue-property-decorator";
export default class LogoSingle extends Vue {}
